import { useState } from "react";
import ListsTab from "@/pages/ListsTab";
import NotesTab from "@/pages/NotesTab";

const KEY = "mytheatre-lists-sub";

/** Lists and notes in one tab: they work the same way (things you write and choose who sees), so a switch is enough. */
export default function ListsNotesTab({ ShowPicker }) {
  const [sub, setSub] = useState(() => { try { return localStorage.getItem(KEY) === "notes" ? "notes" : "lists"; } catch { return "lists"; } });
  const choose = (s) => { setSub(s); try { localStorage.setItem(KEY, s); } catch { /* ignore */ } };
  return (
    <div data-testid="lists-notes-tab">
      <div className="mb-6 inline-flex gap-1 rounded-full border border-border bg-card p-1" role="group" aria-label="Lists or notes">
        {[["lists", "Lists"], ["notes", "Notes"]].map(([k, label]) => (
          <button key={k} type="button" onClick={() => choose(k)} aria-pressed={sub === k} data-testid={`sub-${k}`}
            className={`rounded-full px-5 py-1.5 text-sm font-semibold transition-colors ${sub === k ? "bg-[#C89B3C] text-black" : "text-muted-foreground hover:text-foreground"}`}>{label}</button>
        ))}
      </div>
      {sub === "lists" ? <ListsTab ShowPicker={ShowPicker} /> : <NotesTab ShowPicker={ShowPicker} />}
    </div>
  );
}